/* eslint-disable*/
import React from "react";
import SystemMaintenanceSpecialFunctions_LoanInterestSetup from "./LoanInterestSetup";
import { screen, cleanup } from "@testing-library/react";
import "regenerator-runtime/runtime";
import userEvent from "@testing-library/user-event";
import { act } from "react-dom/test-utils";
import axios from "axios";
import renderTestScreen from "../../../../common/renderTestScreen";
import { t } from "../../../../__mocks__/react-i18next";

describe("LoanInterestSetup Test Cases", () => {
  beforeEach(async () => {
    act(() => {
      renderTestScreen(<SystemMaintenanceSpecialFunctions_LoanInterestSetup />);
    });
  });
  afterEach(cleanup);
  test("is LoanInterestSetup Loads Successfully", () => {
    expect(screen.getByText("LoanInterestSetup")).toBeInTheDocument;
  });
  test("Custom Test Cases for LoanInterestSetup", () => {
    // START_USER_CODE-USER_LoanInterestSetup_Custom_Test_Case
    // END_USER_CODE-USER_LoanInterestSetup_Custom_Test_Case
  });
});
describe("Widget Test Cases", () => {
  beforeEach(async () => {
    act(() => {
      renderTestScreen(<SystemMaintenanceSpecialFunctions_LoanInterestSetup />);
    });
  });
  afterEach(cleanup);
  test("btnAdd(Button Widget) Test Cases", async () => {
    const btnAdd = screen.getByTestId("btnAdd");
    expect(btnAdd).toBeInTheDocument;
    expect(btnAdd.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:LoanInterestSetup_btnAdd")
    );
  });
  test("Custom Test Cases for btnAdd", () => {
    // START_USER_CODE-USER_btnAdd_TEST
    // END_USER_CODE-USER_btnAdd_TEST
  });
  test("btnClose(Button Widget) Test Cases", async () => {
    const btnClose = screen.getByTestId("btnClose");
    expect(btnClose).toBeInTheDocument;
    expect(btnClose.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:LoanInterestSetup_btnClose")
    );
  });
  test("Custom Test Cases for btnClose", () => {
    // START_USER_CODE-USER_btnClose_TEST
    // END_USER_CODE-USER_btnClose_TEST
  });
  test("btnDelete(Button Widget) Test Cases", async () => {
    const btnDelete = screen.getByTestId("btnDelete");
    expect(btnDelete).toBeInTheDocument;
    expect(btnDelete.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:LoanInterestSetup_btnDelete")
    );
  });
  test("Custom Test Cases for btnDelete", () => {
    // START_USER_CODE-USER_btnDelete_TEST
    // END_USER_CODE-USER_btnDelete_TEST
  });
  test("btnEdit(Button Widget) Test Cases", async () => {
    const btnEdit = screen.getByTestId("btnEdit");
    expect(btnEdit).toBeInTheDocument;
    expect(btnEdit.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:LoanInterestSetup_btnEdit")
    );
  });
  test("Custom Test Cases for btnEdit", () => {
    // START_USER_CODE-USER_btnEdit_TEST
    // END_USER_CODE-USER_btnEdit_TEST
  });
  test("grpbxLoanInterestSetup(GroupBox Widget) Test Cases", async () => {
    const grpbxLoanInterestSetup = screen.getByTestId("grpbxLoanInterestSetup");
    expect(grpbxLoanInterestSetup.tagName).toBe("BUTTON");
    expect(grpbxLoanInterestSetup.type).toBe("button");
    expect(grpbxLoanInterestSetup.classList).toContain("btn");
  });
  test("Custom Test Cases for grpbxLoanInterestSetup", () => {
    // START_USER_CODE-USER_grpbxLoanInterestSetup_TEST
    // END_USER_CODE-USER_grpbxLoanInterestSetup_TEST
  });
  test("lblLoanInterest(Label Widget) Test Cases", async () => {
    const lblLoanInterest = screen.getByTestId("lblLoanInterest");
    expect(lblLoanInterest.tagName).toBe("LABEL");
    expect(lblLoanInterest.classList).toContain("form-label");
    expect(lblLoanInterest.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:LoanInterestSetup_lblLoanInterest")
    );
  });
  test("Custom Test Cases for lblLoanInterest", () => {
    // START_USER_CODE-USER_lblLoanInterest_TEST
    // END_USER_CODE-USER_lblLoanInterest_TEST
  });
});
